export const GEN_YEAR_OPTIONS = () => {
  const START_YEAR = 1900;
  const CURRENT_DATE = new Date();
  const NEXT_YEAR = CURRENT_DATE.getFullYear() + 1;
  const yearOptionMapper = (_, i) => {
    const yearOptionValue = NEXT_YEAR - i;
    return {
      label: yearOptionValue,
      value: yearOptionValue,
    };
  };

  return Array.from({ length: NEXT_YEAR - START_YEAR }, yearOptionMapper);
};

export const VEHICLE_TYPE_NAME = 'Vehicle';
